/**
* DevExpress Dashboard (_image-item-properties-composer.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { horizontalAlignment, image64, imageType, sizeMode, urlPath, verticalAlignment } from '../../../model/items/metadata/_image-item';
import { filePickerEditor } from '../../form-adapter/_form-adapter-editors';
import { AccordionTab, KnownTabs } from '../../properties-controller/_accordion-tab';
import { DashboardItemPropertiesComposer } from './_base-properties-composer';
import { SharedComposers } from './_shared-composers';
export class ImageItemPropertiesComposer extends DashboardItemPropertiesComposer {
    constructor(customizeHandler) {
        super(customizeHandler);
    }
    _composeTabsCore(model, args) {
        let visibilityRules = {};
        visibilityRules[image64.propertyName] = (m) => m.imageType() == 'embedded';
        visibilityRules[urlPath.propertyName] = (m) => m.imageType() == 'linked';
        let specificProperties = [
            sizeMode,
            horizontalAlignment,
            verticalAlignment,
            imageType,
            urlPath,
            {
                ...image64,
                formAdapterItem: filePickerEditor({ placeholderId: 'Image', accept: 'image/*', type: 'img' })
            }
        ];
        return [
            new AccordionTab(KnownTabs.Common, 'DashboardWebStringId.AccordionTab.ImageOptions', SharedComposers.getCommonWrapper(model, specificProperties, {}, visibilityRules))
        ];
    }
}
